import { useGlobalForms } from '@lmt/unicorn-shared/app/components/global-forms/useGlobalForms';
import { getCurrentLanguage } from '@lmt/unicorn-shared/app/constants/languages';
import { pages } from '@lmt/unicorn-shared/app/constants/sharedRoutes';
import {
  logOut,
  useClaims,
} from '@lmt/unicorn-shared/app/features/auth/operations';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { getBridge } from 'leo-manager/utils/bridge';
import React, { FC, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToolBarDropDown } from './ToolBarDropDown';

import profileIcon from '@lmt/unicorn-shared/app/icons/profile.svg?react';
import { collectLogs } from '@lmt/unicorn-shared/app/helpers/download-files';
import { isElectron } from '@lmt/unicorn-shared/app/helpers/common';
import { useModal } from '../../common/ui-kit/modal/useModal';

export const ToolBarUserProfile: FC = () => {
  const navigate = useNavigate();
  const i18n = useScopedTranslation('toolbar.user_profile');
  const i18nLanguage = useScopedTranslation('languages');
  const i18nTeamViewer = useScopedTranslation('teamviewer');
  const claims = useClaims();
  const globalForms = useGlobalForms();
  const modals = useModal();
  const doLogOut = useCallback(async () => {
    await logOut();
  }, []);
  const openChangePasswordDialog = useCallback(() => {
    globalForms.changeOwnPassword();
  }, []);
  const openChangeLanguageDialog = useCallback(() => {
    globalForms.changeLanguage();
  }, []);
  const currentLanguage = getCurrentLanguage();

  const runTeamViewer = useCallback(async () => {
    const result = await getBridge().startTeamviewer();
    if (result.type === 'error') {
      await modals.showError({
        text: i18nTeamViewer.t('teamviewer_is_not_found'),
      });
    }
  }, []);

  const options = useMemo(
    () =>
      [
        {
          value: 'language',
          displayValue: i18n.t('language', {
            language: i18nLanguage.t(('language_' + currentLanguage) as any),
          }),
          onClick: openChangeLanguageDialog,
        },
        {
          value: 'logout',
          displayValue: i18n.t('log_out', {
            username: claims.name,
          }),
          onClick: doLogOut,
        },
        {
          value: 'changeOwnPassword',
          displayValue: i18n.t('change_password'),
          onClick: openChangePasswordDialog,
        },
        {
          value: 'collectLogs',
          displayValue: i18n.t('collect_logs'),
          onClick: () => collectLogs(),
          disabled: !isElectron(),
        },
        {
          value: 'openTeamViewer',
          displayValue: i18nTeamViewer.t('open_teamviewer'),
          onClick: () => runTeamViewer(),
          disabled: !isElectron(),
        },
      ].filter((option) => !option.disabled),
    [doLogOut, openChangePasswordDialog, i18nLanguage.i18n.language],
  );
  const userName = useMemo(() => {
    const names = claims.nickname.split(' ');
    if (names.length >= 2) {
      return claims.nickname;
    } else return undefined;
  }, [claims.nickname]);
  return (
    <ToolBarDropDown
      icon={profileIcon}
      badge={userName}
      options={options}
      testId="toolbarUserProfile"
    />
  );
};
